import { createEntityAdapter } from '@reduxjs/toolkit';
import { IClientMessage } from '../../interfaces/IClientMessage';

/** Timestamp used to order a message entity. */
const getSortTimestamp = (message?: IClientMessage) => {
	const { _timestamp, timestamp, _meta } = message ?? {};
	return (
		_timestamp ??
		timestamp ??
		(typeof _meta?.sent === 'string' ? _meta.sent : Infinity.toString())
	);
};

const sortComparer = (a: IClientMessage, b: IClientMessage) =>
	getSortTimestamp(a).localeCompare(getSortTimestamp(b));

export const messagesAdapter = createEntityAdapter<IClientMessage>({
	sortComparer,
	selectId: (message) => message.client_id,
});
export const _messagesSelectors = messagesAdapter.getSelectors();
